import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for interacting with your database
export const supabase = createClient(
    'https://rgfnmixxdkxfzwvgzyio.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyNzcxOTYwOSwiZXhwIjoxOTQzMjk1NjA5fQ.Kdc46LzmHi6xZthPMUYM7egbetty-Sd4LNtOAushT60'
);
